import Black from '@/assets/oldgill/fonts/Roboto-Black.ttf';
import BlackItalic from '@/assets/oldgill/fonts/Roboto-BlackItalic.ttf';
import Bold from '@/assets/oldgill/fonts/Roboto-Bold.ttf';
import BoldItalic from '@/assets/oldgill/fonts/Roboto-BoldItalic.ttf';
import ExtraLight from '@/assets/oldgill/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '@/assets/oldgill/fonts/Roboto-ThinItalic.ttf';
import Light from '@/assets/oldgill/fonts/Roboto-Light.ttf';
import LightItalic from '@/assets/oldgill/fonts/Roboto-LightItalic.ttf';
import Regular from '@/assets/oldgill/fonts/Roboto-Regular.ttf';
import Italic from '@/assets/oldgill/fonts/Roboto-Italic.ttf';
import SemiBold from '@/assets/oldgill/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '@/assets/oldgill/fonts/Roboto-MediumItalic.ttf';

import BowlbyOne from '@/assets/oldgill/fonts/BowlbyOne-Regular.ttf';
import BowlbyOneSC from '@/assets/oldgill/fonts/BowlbyOneSC-Regular.ttf';
import Hitchcut from '@/assets/oldgill/fonts/Hitchcut-Regular.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'Bowlby One';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${BowlbyOne}') format('opentype');
  }

  @font-face {
    font-family: 'Bowlby One SC';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${BowlbyOneSC}') format('opentype');
  }

  @font-face {
    font-family: 'Hitchcut';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Hitchcut}') format('opentype');
  }
`;
